module.exports = require("./mk.d.ts");